import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class ShowIfAuthorised extends React.Component {
  render = () => {
    return (
      <>
        {this.props.allowedRoles.forEach(role => {
          if (!role) console.log("ERROR: role was not set");
        })}

        {this.props.isLoggedIn &&
          this.props.allowedRoles &&
          this.props.allowedRoles.indexOf(this.props.role) !== -1 &&
          this.props.children}
      </>
    );
  };
}

ShowIfAuthorised.propTypes = {
  allowedRoles: PropTypes.array.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  role: PropTypes.string,
  children: PropTypes.node.isRequired
};

const mapStateToProps = state => {
  const { isLoggedIn, role } = state.auth;

  return {
    isLoggedIn,
    role
  };
};

export default connect(
  mapStateToProps,
  null
)(ShowIfAuthorised);
